import React, { useEffect, useState } from 'react';
import { Ai2Layout } from '../../layout/Ai2Layout';
import DataAnnotationProvider from './context/DataAnnotationProvider';
import QuestionsSidebar from './components/QuestionsSidebar';
import AnnotationContent from './components/AnnotationContent';
import { SystemPermission } from '../../../context';
import useUserPermission from '../../hooks/useUserPermission';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../store';
import { useNavigate } from 'react-router-dom';

interface DataAnnotationPageProps {
  discrepency?: boolean;
}
const DataAnnotationPage = ({ discrepency }: DataAnnotationPageProps) => {
  const [resource, setResource] = useState('');
  const { userHasPermissions } = useUserPermission();
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );
  const navigate = useNavigate();
  const permissionShouldBeChecked = discrepency
    ? SystemPermission.ADD_FEEDBACK_V2
    : SystemPermission.ADD_FEEDBACK;

  useEffect(() => {
    // e.g. "/data-annotation"
    const path = window.location.pathname;
    // split on "/" and grab the first non-empty segment
    const segments = path.split('/').filter(Boolean);
    setResource(segments[0] || '');
  }, []);
  if (
    selectedTenancy &&
    selectedTenancy?.permissionsSetup &&
    !userHasPermissions(permissionShouldBeChecked)
  ) {
    navigate('/');
    return null;
  }
  return (
    <Ai2Layout>
      <DataAnnotationProvider discrepency={discrepency}>
        <div className="data-annotation-container">
          <QuestionsSidebar
            className="feedback-sidebar-container px-3 h-100"
            sideBarType={
              resource === 'data-annotation'
                ? 'default'
                : 'data-annotation-resolving'
            }
          />
          <AnnotationContent />
        </div>
      </DataAnnotationProvider>
    </Ai2Layout>
  );
};

export default DataAnnotationPage;
